<template>
  <div>
    <Head :title="title" />

    <jet-banner />

    <div class="flex flex-col min-h-screen bg-gray-100">
      <nav
        v-if="!isWebview"
        class="bg-white border-b border-gray-100">
        <!-- Primary Navigation Menu -->
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="flex justify-between h-16">
            <div class="flex">
              <!-- Logo -->
              <div class="flex-shrink-0 flex items-center">
                <inertia-link :href="route('client-examinations')">
                  <img
                    class="mx-auto h-8 w-auto"
                    src="/img/andVet_logo.png" />
                </inertia-link>
              </div>

              <!-- Navigation Links -->
              <div
                class="hidden space-x-8 text-base sm:-my-px sm:ml-10 sm:flex">
                <jet-nav-link
                  :href="route('client-examinations')"
                  :active="route().current('client-examinations')">
                  模試の受験/購入
                </jet-nav-link>
                <jet-nav-link
                  :href="route('result')"
                  :active="route().current('result')">
                  成績
                </jet-nav-link>
              </div>
            </div>

            <div class="flex items-center ml-14">
              <!-- Settings Dropdown -->
              <div class="ml-3 relative">
                <jet-dropdown
                  align="right"
                  width="48">
                  <template #trigger>
                    <div class="relative">
                      <span class="inline-flex rounded-md">
                        <button
                          type="button"
                          class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-gray-500 bg-white hover:text-gray-700 focus:outline-none transition">
                          <div
                            class="w-[40vw] md:w-[20vw] text-right whitespace-nowrap overflow-x-hidden overflow-ellipsis">
                            {{ clientUserEmail }}
                          </div>
                          <svg
                            class="ml-2 -mr-0.5 h-4 w-4"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor">
                            <path
                              fill-rule="evenodd"
                              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                              clip-rule="evenodd" />
                          </svg>
                        </button>
                      </span>
                      <!-- <p class="absolute right-6 top-7 text-sm text-gray-500">{{VerifiedEmailText}}</p> -->
                    </div>
                  </template>

                  <template #content>
                    <!-- <div class="block px-4 py-2 text-xs text-gray-400">
                      アカウント管理
                    </div> -->

                    <jet-dropdown-link :href="route('client.user.info')">
                      ユーザ情報確認
                    </jet-dropdown-link>

                    <div class="border-t border-gray-100"></div>

                    <jet-dropdown-link :href="route('client.credential.show')">
                      アカウント情報変更
                    </jet-dropdown-link>

                    <div class="border-t border-gray-100"></div>

                    <jet-dropdown-link :href="route('client.profile.show')">
                      プロフィール変更
                    </jet-dropdown-link>

                    <div class="border-t border-gray-100"></div>

                    <form @submit.prevent="logout">
                      <jet-dropdown-link as="button">
                        ログアウト
                      </jet-dropdown-link>
                    </form>
                  </template>
                </jet-dropdown>
              </div>
              <button
                class="relative z-20 flex h-11 w-11 items-center justify-center sm:hidden"
                @click="toggleBtn">
                <span class="relative block h-5 w-6">
                  <span
                    :class="
                      isOpen
                        ? 'transform rotate-45 top-2 w-7 transition duration-300'
                        : 'top-0 w-6'
                    "
                    class="absolute right-0 inline-block h-0.5 rounded bg-black transition-all"></span>
                  <span
                    :class="isOpen ? 'hidden' : 'top-2 w-6'"
                    class="absolute right-0 inline-block h-0.5 bg-black transition-all"></span>
                  <span
                    :class="
                      isOpen
                        ? 'transform -rotate-45 top-2 w-7 transition duration-300'
                        : 'top-4 w-6'
                    "
                    class="absolute right-0 inline-block h-0.5 rounded bg-black transition-all"></span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </nav>

      <!-- Page Heading -->
      <!-- <header
        class="bg-white shadow"
        v-if="$slots.header">
        <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
          <slot name="header"></slot>
        </div>
      </header> -->

      <!-- Page Content -->
      <main class="flex-grow">
        <slot></slot>
        <flash-messages />
      </main>
      <div
        v-if="!isWebview"
        class="text-left">
        <nav
          :class="isOpen ? '-right-0 opacity-100' : '-right-full opacity-0'"
          class="fixed z-10 bg-white top-0 button-0 text-current w-52 h-screen transition-all duration-300">
          <div class="pt-12 px-6">
            <ul class="m-0 p-0 list-none">
              <li class="m-0 border-b-2">
                <a
                  class="block text-gray-600 active:text-gray-300 text-sm p-3 no-underline duration-150"
                  :href="route('client-examinations')"
                  :active="route().current('client-examinations')">模試の受験/購入</a>
              </li>
              <li class="m-0 border-b-2">
                <a
                  class="block text-gray-600 active:text-gray-300 text-sm p-3 no-underline duration-150"
                  :href="route('result')"
                  :active="route().current('result')">成績</a>
              </li>
            </ul>
          </div>
        </nav>
        <div
          :class="
            isOpen
              ? 'block bg-black w-full h-full top-0 left-0 fixed opacity-80 z-2 cursor-pointer'
              : 'hidden transition-all duration-500'
          "
          @click="toggleBtn"></div>
      </div>

      <footer
        v-if="!isWebview"
        class="bg-white shadow">
        <div
          class="mx-auto flex max-w-7xl justify-center py-4 text-left text-sm md:justify-end sm:px-4 sm:py-6 lg:px-8">
          <div class="text-gray-600 px-2 hover:text-black">
            <a
              class="block"
              :href="route('guide.company')">運営会社について</a>
          </div>
          <div class="text-gray-600 px-2">
            <a
              class="block hover:text-black"
              :href="route('guide.terms')">利用規約</a>
            <a
              class="block pt-3 hover:text-black"
              :href="route('guide.privacy')">プライバシーポリシー</a>
            <a
              class="block pt-3 hover:text-black"
              :href="route('guide.asct')">特定商取引法に基づく表記</a>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import { Head, usePage } from '@inertiajs/inertia-vue3'
import JetBanner from '@/Jetstream/Banner'
import JetDropdown from '@/Jetstream/Dropdown'
import JetDropdownLink from '@/Jetstream/DropdownLink'
import JetNavLink from '@/Jetstream/NavLink'
import FlashMessages from '@/Common/FlashMessages'

const isOpen = ref(false)
const isWebview = computed(() => usePage().props.value.client.isWebview === true)
const scrollControl = () => {
  if (isOpen.value) {
    document.documentElement.style.overflow = 'hidden'
  } else {
    document.documentElement.style.overflow = 'auto'
  }
}
const toggleBtn = () => {
  isOpen.value = !isOpen.value
  scrollControl()
}

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
})

const clientUserEmail = computed(() => {
  const emailName = usePage().props.value.client.user.email
  return emailName.substring(0, emailName.lastIndexOf('@'))
})

const logout = () => Inertia.post(route('clients.logout.post'))
</script>
